import Vue from '@/main'
import config from '@/config'
import axios from 'axios'

axios.defaults.baseURL = config['proyectos'][process.env.VUE_APP_PROYECTO][process.env.NODE_ENV].API_BASE_URL;

export default {
    nuevaVersion () {
        Vue.$swal.fire({
            title: 'Nueva versión disponible.',
            text: 'Actualice ahora para aprovechar los nuevos cambios en la app.',
            type: 'success',
            showConfirmButton: true,
            confirmButtonText: 'Recargar',
            backdrop: 'rgb(239, 239, 239)',
            allowOutsideClick: false,
            showCloseButton: true,
        }).then((result) => {
            if (result.value) {
                navigator.serviceWorker.getRegistrations().then(
                    function(registrations) {
                        for(let registration of registrations) {
                            registration.unregister()
                        }
                        location.reload(true);
                    }
                )
            }
        });
    },

    noAutorizado (titulo, mensaje, boton = false) {
        this.logout(false);
        if (Vue.$route.meta.privada) {
            Vue.$swal.fire({
                title: titulo,
                text: mensaje,
                type: 'warning',
                showConfirmButton: boton,
                confirmButtonText: 'Iniciar sesión',
                backdrop: 'rgb(239, 239, 239)',
                allowOutsideClick: false,
                showCloseButton: false,
            }).then((result) => {
                if (result.value) {
                    Vue.$router.push({name: 'login', query: {logout: 1, redirect: encodeURIComponent(Vue.$router.currentRoute.fullPath) }})
                }
            });
        }
    },

    get (url, success, err, always = () => {} ) {
        return axios.get(
            url,
            {
                headers: {'Authorization': 'Bearer ' + Vue.$store.state.access_token}
            }
        )
        .then(success)
        .catch(err)
        .finally(always);
    },

    post (url, data, success, err, always = () => {} ) {
        return axios.post(
            url,
            data,
            {
                headers: {'Authorization': 'Bearer ' + Vue.$store.state.access_token}
            }
        )
        .then(success)
        .catch(err)
        .finally(always);
    },

    uxGET (url, success, err = () => {}, always = () => {} ) {
        return axios.get(
            url,
            {
                headers: {
                    // 'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + Vue.$store.state.access_token
                }
            }
        )
        .then((res) => {
            success(res)
        })
        .catch((res) => {
            this.errores(res)
            err(res)
        })
        .finally(() => {
            always()
        })
    },

    uxPOST (url, data, success, err = () => {}, always = () => {}) {
        return axios.post(
            url,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + Vue.$store.state.access_token
                }
            }
        )
        .then((res) => {
            success(res)
        })
        .catch((res) => {
            this.errores(res)
            err(res)
        })
        .finally(() => {
            always()
        });
    },

    uxPATCH (url, data, success, err = () => {}, always = () => {}) {
        return axios.patch(
            url,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + Vue.$store.state.access_token
                }
            }
        )
        .then((res) => {
            success(res)
        })
        .catch((res) => {
            this.errores(res)
            err(res)
        })
        .finally(() => {
            always()
        });
    },

    uxDELETE (url, data, success, err = () => {}, always = () => {}) {
        return axios.delete(
            url,
            {
                headers: {
                    'Authorization': 'Bearer ' + Vue.$store.state.access_token,
                    'Content-Type': 'application/json',
                },
                params: data
            }
        )
        .then((res) => {
            success(res)
        })
        .catch((res) => {
            this.errores(res)
            err(res)
        })
        .finally(() => {
            always()
        });
    },

    errores (res) {
        if ( ( ! res.response ) || res.response.status == 500 ) {
            Vue.$swal.fire({
                icon: false,
                showConfirmButton: false,
                html: '<img class="w-100" src="/img/icons/error.svg">',
            });
        } else if ( res.response.status == 403 ) {
            this.noAutorizado('No autorizado', res.response.data, true);
        } else if ( res.response.status == 451 ) {
            this.noAutorizado('Su sesión ha caducado.', 'Por favor, inicie sesión nuevamente', true);
        } else {
            Vue.$swal.fire('Oops', res.response.data, 'warning');
        }
    },

    relojRenovarSesion () {
        console.warn(Vue.$store.state);
        // var intervalo = Vue.$store.state.intervalo;
        // if (intervalo) {
        //     clearInterval(intervalo);
        // }
        // if ( Vue.$store.state.refresh_token ) {
        //     Vue.$store.commit(
        //         'intervalo',
        //         setInterval(function(){
        //             this.renovarSesion();
        //         }.bind(this), (10000))
        //     )
        // }
    },

    persistirSesion (datos, reloj = false) {
        if (datos.access_token) {
            Vue.$store.commit('guardar_access_token', datos.access_token)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + datos.access_token;
        }
        if (datos.refresh_token) {
            Vue.$store.commit('guardar_refresh_token', datos.refresh_token)
        }
        if (datos.permisos) {
            Vue.$store.commit('guardar_permisos', datos.permisos)
        }
    },

    renovarSesion () {
        if ( ! navigator.onLine ) {
            return false;
        }
        axios.get(
            'auth/renovar-sesion',
            {
                headers: {'Authorization': 'Bearer ' + Vue.$store.state.refresh_token}
            }
        )
        .then((response) => {
            this.persistirSesion(response.data)
        })
        .catch((error) => {
            this.noAutorizado('No autorizado', error.response.data, true);
        });
    },

    logout (redirigir = true) {
        axios.post('auth/logout')
        delete axios.defaults.headers.common['Authorization'];
        Vue.$store.commit('cerrar_sesion')
        if (redirigir) {
            Vue.$router.push({name: 'login', query: {logout: 1, redirect: encodeURIComponent(Vue.$router.currentRoute.fullPath) }})
        }
    },

}
